var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-image',{attrs:{"src":"http://via.placeholder.com/1200x768","thumb_src":"http://via.placeholder.com/64x64","slide":true,"fancybox":true,"width":"1200","height":"768"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }